import { Box, styled, Container } from "@mui/material";
import { UnderConstruction } from "../components";

const PageWrapper = styled(Box)(() => ({
    paddingTop: "120px",
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    paddingBottom: "80px",
    justifyContent: "center",
}));

export const TermsOfServicePage = () => {
    return (
        <Container>
            <PageWrapper>
                <UnderConstruction>
                    Мы готовим актуальные условия использования сервиса. <br />
                    Они будут опубликованы в ближайшее время.
                </UnderConstruction>
            </PageWrapper>
        </Container>
    );
};
